import { connect } from 'react-redux';
import { EssentialUpgradeButton } from '../../components/EssentialUpgradeButton';
import { IEssentialUpgradeButtonEvents } from '../../components/types';
import { onUpgrade } from './events/onUpgrade';
import { IEssentialUpgradeButtonHOCProps } from './types';

const mapDispatchToProps = (
    dispatch: any,
    { onClick }: IEssentialUpgradeButtonHOCProps
): IEssentialUpgradeButtonEvents => {
    return {
        onUpgrade: () => dispatch(onUpgrade(onClick))
    }
};

export const EssentialUpgradeButtonHOC = connect(
    null,
    mapDispatchToProps
)(EssentialUpgradeButton);

EssentialUpgradeButtonHOC.displayName = 'EssentialUpgradeButtonHOC';
